import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-339b9516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mn-card mn-card--slide" }
const _hoisted_2 = { class: "mn-card mn-card--main" }

import { ref } from 'vue'
import Slide from '@/layouts/default/profile/SlideProfile.vue'
import DefaultBreadcrumb from '@/components/ant/breadcrumb/DefaultBreadcrumb.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageNews',
  setup(__props) {

const slideCollapsed = ref(true)

const onSlideCollapsedChange = (value: boolean) => {
  slideCollapsed.value = value
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: _normalizeClass(["mn-layout", { 'is-slide-collapsed': slideCollapsed.value }]),
    gutter: [16, 16]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 0,
        lg: slideCollapsed.value ? 2 : 6,
        class: "mn-layout__col mn-layout__col--slide"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Slide, { onCollapsedChange: onSlideCollapsedChange })
          ])
        ]),
        _: 1
      }, 8, ["lg"]),
      _createVNode(_component_a_col, {
        xs: 24,
        lg: slideCollapsed.value ? 22 : 18,
        class: "mn-layout__col mn-layout__col--main"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(DefaultBreadcrumb),
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      }, 8, ["lg"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})